import React, { useState } from 'react';
import { FaPlus, FaTrashAlt } from 'react-icons/fa';
import Paginator from '../../../../../utils/Paginator';
import { Venue } from '../../../../../api/apiTypes';

type ListaMercatiModaleProps = {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    lista: Venue[];
    onAdd: (id?: string | number) => void; // <-- string | number
    onRemove: (id: string | number) => void; // <-- string | number
    isEditing: boolean;
    isAmbiguousList: boolean;
};


const PlusIcon = FaPlus as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const TrashIcon = FaTrashAlt as React.ComponentType<React.SVGProps<SVGSVGElement>>;

const ListaMercatiModale: React.FC<ListaMercatiModaleProps> = ({
    isOpen,
    onClose,
    title,
    lista,
    onAdd,
    onRemove,
    isEditing,
    isAmbiguousList,
}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 6;

    const totalPages = Math.ceil(lista.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedList = lista.slice(startIndex, endIndex);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        localStorage.setItem('currentPage_best_execution', page.toString());
    };

    if (!isOpen) return null;

    // 🔹 Layout griglia
    const gridLayout =
        isAmbiguousList || title === 'Da assegnare'
            ? 'grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_auto_auto]' // 2 colonne AZIONI
            : 'grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_auto]';   // 1 colonna AZIONI

    // Mostra colonne AZIONI
    const showActionColumns = isEditing || isAmbiguousList || title === 'Da assegnare';

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex justify-center items-start pt-8">
            <div className="relative p-3 border w-full max-w-6xl shadow-lg rounded-md bg-white">
                {/* Header */}
                <div className="flex justify-between items-center pb-6">
                    <h3 className="text-2xl font-bold text-gray-900">{title}</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-3xl">
                        &times;
                    </button>
                </div>

                {/* Tabella */}
                <div className="bg-surface rounded-lg shadow-md overflow-hidden">
                    {/* Riga degli Header */}
                    <div className={`grid gap-x-4 p-6 border-b border-divider font-semibold text-textSecondary ${gridLayout}`}>
                        <div className="flex items-center">MARKET NAME</div>
                        <div className="flex justify-center items-center">MIC</div>
                        <div className="flex justify-center items-center">OMIC</div>
                        <div className="flex justify-center items-center">LEGAL ENTITY</div>
                        <div className="flex justify-center items-center">ACRONIMO</div>
                        <div className="flex justify-center items-center">STATO</div>

                        {showActionColumns && <div className="flex justify-center items-center">AZIONI</div>}
                        {(isAmbiguousList || title === 'Da assegnare') && <div className="flex justify-center items-center"></div>}
                    </div>

                    {/* Righe dati */}
<div className="divide-y divide-divider">
  {paginatedList.length > 0 ? (
    paginatedList.map((item, index) => (
      <div
        // ✅ Usa una key unica combinando id con l'indice
key={`${(item as any).id || item.id}-${startIndex + index}`}
        className={`grid gap-x-4 p-4 hover:bg-gray-50 transition duration-150 ease-in-out items-center ${gridLayout}`}
      >
        <div className="flex items-center text-textPrimary ml-2">{item.market_name}</div>
        <div className="flex justify-center items-center text-primary">{item.mic}</div>
        <div className="flex justify-center items-center text-primary">{item.operating_mic}</div>
        <div className="flex justify-center items-center text-primary">{item.legal_entity_name}</div>
        <div className="flex justify-center items-center text-primary">{item.acronym}</div>
        <div className="flex justify-center items-center text-primary">{item.status}</div>

        {showActionColumns && (
          <>
            {/* Bottone Aggiungi (+) */}
            {(isAmbiguousList || (isEditing && title === 'Da assegnare')) && (
              <div className="flex justify-center items-center">
                <button
                  onClick={() => {
                    onAdd((item as any).id || item.id);
                  }}
                  className="bg-textPrimary-600 hover:text-green-800 p-2 rounded-full hover:bg-gray-200"
                  title="Aggiungi"
                >
                  <PlusIcon />
                </button>
              </div>
            )}

            {/* Bottone Rimuovi (-) */}
           <div className="flex justify-center items-center">
  <button
onClick={() => onRemove(item.id as string | number)}
    className="bg-textPrimary-600 hover:text-red-800 p-2 rounded-full hover:bg-gray-200"
    title="Rimuovi"
  >
    <TrashIcon />
  </button>
</div>
          </>
        )}
      </div>
    ))
  ) : (
    <div className="p-4 text-center text-gray-500">Nessun elemento trovato.</div>
  )}
</div>
                </div>

                {/* Bottone Aggiungi sotto la tabella (solo per liste non ambigue e non Da assegnare) */}
                {isEditing && !isAmbiguousList && title !== 'Da assegnare' && (
                    <div className="flex justify-end p-4">
                       {paginatedList.map(item => (
            <button
                key={item.id}
                onClick={() => onAdd(item.id)}
                className="bg-buttonPrimaryBg text-buttonPrimaryText hover:bg-buttonPrimaryHover px-4 py-2 rounded-lg text-base font-medium flex items-center"
            >
                Aggiungi {item.market_name}
                <PlusIcon className="ml-2" />
            </button>
        ))}
        
                    </div>
                )}

{/* Bottone globale "Aggiungi Mercato" */}
{isEditing && (
  <div className="flex justify-end mt-4">
    <button
      onClick={() => {
        onAdd();
      }}
      className="px-4 py-2 bg-textPrimary text-white hover:bg-textSecondary rounded flex items-center"
    >
      Aggiungi Mercato
      <PlusIcon className="ml-2" />
    </button>
  </div>
)}

                {/* Paginatore */}
                {totalPages > 0 && (
                    <div className="p-4">
                        <Paginator
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ListaMercatiModale;
